<template>
  <form>
    <div class="row">
      <div class="col-md-6">
        <fg-input type="text"
                  label="Téléphone"
                  placeholder="Numéro de téléphone"
                  v-model="model.phoneNumber">
        </fg-input>
      </div>
      <div class="col-md-6">
        <fg-input type="text"
                  label="Email"
                  placeholder="Email"
                  v-model="model.email">
        </fg-input>
      </div>
    </div>

    <div class="row">
      <div class="col-md-8">
        <div class="form-group">
          <label>Informations</label>
          <textarea rows="5" class="form-control border-input"
                    placeholder="Informations complémentaires (ex: Horaires)"
                    v-model="model.info">

          </textarea>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Photo</label>
          <img style="cursor: pointer;" @click="$refs.input.click()" class="avatar border-white" :src="model.picture ? model.picture.url : 'static/img/default-store.png'" alt="...">
          <input
            v-show="false"
            ref="input"
            accept="image/*"
            type="file"
            @change="fileSelected">
        </div>
      </div>
    </div>
    <div class="clearfix"></div>
  </form>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import firebase from 'firebase'
  import PProgress from 'src/components/UIComponents/Progress.vue'
  import { mapGetters } from 'vuex'

  function uploadFile (file, to, success, progress, error) {
    const metadata = {
      cacheControl: 'public,max-age=3600',
      contentType: file.type,
      customMetadata: {
        owner: firebase.auth().currentUser.uid
      }
    }
    const upload = firebase.storage()
      .ref(to)
      .put(file, metadata)
    upload.on('state_changed', (snapshot) => {
      progress((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    }, (err) => {
      error(err)
    }, (res) => {
      success(upload.snapshot.downloadURL)
    })
  }

  export default {
    computed: {
      ...mapFields(['phoneNumber', 'email', 'picture'])
    },
    data () {
      return {
        uploading: 0,
        model: {
          phoneNumber: '',
          email: '',
          info: '',
          picture: null
        },
        modelValidations: {
          phoneNumber: {
            numeric: true
          },
          email: {
            email: true
          },
          picture: {
            url: true
          }
        }
      }
    },
    methods: {
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      validate () {
        return this.$validator.validateAll()
      },
      fileSelected (ev) {
        const file = ev.target.files[0]
        if (file) {
          this.model.picture = file
          this.$set(this.model.picture, 'url', URL.createObjectURL(file))
        }
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Store/Add/SecondStep.vue